//function to get the other concept e.g. question, strategy
export function pluralConcepts (concept) {
	return concept == 'question' ? 'questions': 'strategies'
}
